import { Loader2, RefreshCw, WifiOff } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface AuthUnavailableScreenProps {
  onRetry: () => void;
  /** Sortida per a qui no vol esperar: tanca la sessió d'aquest dispositiu i porta al login. */
  onSignOut: () => void;
  retrying?: boolean;
}

/**
 * Hi ha sessió desada però no s'ha pogut comprovar (sense xarxa, o el servidor reiniciant-se
 * durant un deploy). No s'ha esborrat res: n'hi ha prou de tornar-ho a provar.
 */
export default function AuthUnavailableScreen({
  onRetry,
  onSignOut,
  retrying = false,
}: AuthUnavailableScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="flex w-full max-w-xs flex-col items-center space-y-4 text-center" role="alert">
        <WifiOff className="h-12 w-12 text-gray-400" aria-hidden="true" />
        <div className="space-y-1">
          <h1 className="text-lg font-semibold text-gray-900">No s'ha pogut connectar</h1>
          <p className="text-sm text-gray-600">La sessió segueix oberta.</p>
        </div>
        <Button className="w-full" size="lg" onClick={onRetry} disabled={retrying}>
          {retrying ? (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />
          ) : (
            <RefreshCw className="mr-2 h-4 w-4" aria-hidden="true" />
          )}
          Torna-ho a provar
        </Button>
        <Button variant="ghost" size="sm" className="text-gray-500" onClick={onSignOut} disabled={retrying}>
          Tanca la sessió
        </Button>
      </div>
    </div>
  );
}
